var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Classes.Utilities = OCS.Classes.Utilities || {};
OCS.Functions = OCS.Functions || {};
OCS.Functions.init_utilities = function () {
    // The generic utilities
    var impl = [OCS.Classes.Utilities.base, OCS.Classes.Utilities.text, OCS.Classes.Utilities.array, OCS.Classes.Utilities.object, OCS.Classes.Utilities.calculations];
    /* istanbul ignore if */
    if (OCS.is_worker) {
        // Since we are a worker, image and html logic not needed
        OCS.Classes.Utilities.worker = new Class({
            Implements: impl
        });
        return new OCS.Classes.Utilities.worker();
    } else {
        impl.push(OCS.Classes.Utilities.color);
        OCS.Classes.Utilities.general = new Class({
            Implements: impl
        });
        return new OCS.Classes.Utilities.general();
    }
};

// Kick off the initialization of utilities
OCS.Utilities = OCS.Functions.init_utilities();



/**
 * Additional Prototype Based Methods to Include
 */
/* istanbul ignore next */
String.prototype.trunc = function (n, useWordBoundary) {
    var toLong = this.length > n,
            s_ = toLong ? this.substr(0, n - 1) : this;
    s_ = useWordBoundary && toLong ? s_.substr(0, s_.lastIndexOf(' ')) : s_;
    return  toLong ? s_ + '&hellip;' : s_;
};
String.prototype.format = function () {
    var formatted = this;
    for (var arg in arguments) {
        formatted = formatted.replace("{" + arg + "}", arguments[arg]);
    }
    return formatted;
};